import { лог } from './dev-log.js';
import * as loader from './ui/loader.js';

/**
 * Счётчик скачанного на экране загрузки: «12.4 из 96.8 МБ · 26 %».
 *
 * ⚠️ ЗАВЕДЕНО РАДИ МЕДЛЕННОГО КАНАЛА, И ЭТО НЕ УКРАШЕНИЕ. Проценты этапов
 * стоят подолгу: «разматываю катушку» висит на двух процентах, пока едут
 * тридцать мегабайт снасти. Со стороны это неотличимо от зависания — человек
 * закрывает вкладку. Растущие мегабайты видно каждую секунду, и они отвечают
 * на единственный вопрос, который у него есть: сколько ещё ждать.
 *
 * ⚠️ РАНЬШЕ СТРОКА ПОЯВЛЯЛАСЬ В САМОМ КОНЦЕ И СРАЗУ СО «ВСЁ ГОТОВО», И ВОТ
 * ПОЧЕМУ. Итог спрашивался пятнадцатью HEAD-запросами, а браузер держит к
 * одному узлу шесть соединений: пока по ним ползут модели и текстуры, запросы
 * о размерах ЖДУТ ОЧЕРЕДИ и отвечают последними. До ответа знаменателя нет, а
 * без знаменателя строка не рисуется вовсе — вот она и выскакивала на восьми
 * десятых пути, когда всё уже приехало.
 *
 * Лечится двумя переменами, и обе здесь:
 *
 *   РАЗМЕРЫ СПРАШИВАЕМ ДО ТОГО, как началась тяжёлая загрузка, — из boot.ts,
 *   ещё до ввоза движка. В тот миг соединения свободны, и ответы приходят за
 *   доли секунды.
 *
 *   ПОКА ИТОГА НЕТ, ПОКАЗЫВАЕМ ХОТЬ ЧТО-ТО: одни пришедшие мегабайты, без
 *   знаменателя. Растущее число само по себе говорит «идёт», а это и есть
 *   главное, что нужно человеку.
 *
 * ⚠️ ЧИСЛО РАСТЁТ НЕПРЕРЫВНО, А НЕ СТУПЕНЯМИ ПО ФАЙЛУ. PerformanceObserver
 * сообщает о ресурсе, только когда тот ДОКАЧАЛСЯ: одна модель на двенадцать
 * мегабайт — это полминуты неподвижного счётчика, а потом скачок. Поэтому
 * поверх него стоит заплата на XMLHttpRequest: у него есть события progress,
 * и байты видно прямо в полёте. Ими Babylon и грузит модели.
 */

/**
 * Снасть в руках и сам рыболов.
 *
 * ⚠️ КАРТИНКИ ТЕПЕРЬ ОТДЕЛЬНЫМИ ФАЙЛАМИ, И ИХ НАДО СЧИТАТЬ ЗДЕСЬ. Раньше они
 * лежали ВНУТРИ каждой модели, и весь их вес приходил вместе с ней — списку
 * хватало четырёх имён. Вынесенные наружу, они стали отдельными запросами: не
 * впиши мы их сюда, знаменатель полосы недосчитается восьми мегабайт, а
 * числитель их не увидит вовсе, и доля скачанного окажется завышенной.
 *
 * ⚠️ ИМЕНА — ОТПЕЧАТКИ СОДЕРЖИМОГО, И ПОСТАВЛЕНЫ СЮДА ИНСТРУМЕНТОМ. Меняли
 * модели — перегоните tools/glb-externalize.mjs и перепишите этот список его
 * выводом. Совпадать он обязан ровно: лишнее имя раздует знаменатель и полоса
 * не дойдёт до конца, недостающее — наоборот.
 *
 * ⚠️ ОДНА КАРТА ЦВЕТА НА ТРИ ЧАСТИ КАТУШКИ — ЭТО НЕ ОПЕЧАТКА. Корпус, ручка и
 * дужка красятся одной и той же картинкой; прежде она лежала в каждом файле
 * своей копией, и одни и те же 2.72 МБ приезжали трижды.
 */
/**
 * Карта цвета катушки — одна на корпус, ручку и дужку.
 *
 * ⚠️ ЕЁ НАДО ЗАБРАТЬ ЗАРАНЕЕ, И ОДНОГО ФАЙЛА ДЛЯ ЭТОГО МАЛО. Вынести картинку
 * из трёх контейнеров в один файл — только половина дела: три части катушки
 * грузятся ПАРАЛЛЕЛЬНО (см. buildReel в rod-view.ts), и все три запроса за
 * этой картой уходят раньше, чем успевает вернуться первый. HTTP-кеш тут
 * бессилен — переиспользовать нечего, ответа ещё нет ни одного.
 *
 * Замерено на собранной игре с заголовком `immutable`: запрошена четырежды,
 * скачана трижды, 8.16 МБ вместо 2.72, попаданий в кеш — ноль.
 *
 * ⚠️ ПРЕДЗАГРУЗКОЙ ЭТО НЕ ЛЕЧИТСЯ — ПРОВЕРЕНО ДВАЖДЫ. Тег
 * `<link rel="preload" as="image">` браузер не признал: Babylon берёт картинки
 * glTF обычным запросом, а не как изображение, и он же написал в журнал
 * «preloaded but not used». Свой запрос тем же XHR тоже не помог: три
 * обращения движка уходят ОДНОВРЕМЕННО и разминаются с кешем друг друга —
 * стало 5 запросов и 10.87 МБ вместо прежних 8.16, то есть хуже.
 *
 * Лечится это только там, где рождается: в rod-view.ts, где три части катушки
 * запрашиваются разом. Либо свести их в один файл, либо грузить по очереди,
 * дожидаясь готовности текстуры. И то и другое меняет вид снасти на экране, а
 * проверить вид сейчас нечем — поэтому оставлено как есть и записано здесь.
 */
const ОБЩАЯ_КАРТА_КАТУШКИ = '/rods/tex/9d8a482549a9.jpg';

const СНАСТЬ = [
  '/rods/handle.glb?v=5',
  '/rods/reel_body.glb?v=5',
  '/rods/reel_crank.glb?v=5',
  '/rods/reel_bail.glb?v=5',
  // рукоять: цвет и нормали
  '/rods/tex/20b3f9d55f89.jpg',
  '/rods/tex/59728ecb94dd.jpg',
  ОБЩАЯ_КАРТА_КАТУШКИ,
  '/angler.glb',
];

/** Земля: этими картами красится берег и дно. */
const ЗЕМЛЯ = [
  '/textures/terrain/grass_dense.jpg',
  '/textures/terrain/grass_dry.jpg',
  '/textures/terrain/sand_clean.jpg',
  '/textures/terrain/forest_earth.jpg',
  '/textures/terrain/rock_cliff.jpg',
  '/textures/terrain/gravel_algae.jpg',
  '/textures/terrain/aquatic_plants.jpg',
  '/textures/terrain/deep_mud_algae.jpg',
  '/textures/terrain/sandy_bottom_weeds.jpg',
];

/**
 * Прибрежная зелень: камыш и кувшинки.
 *
 * ⚠️ ЗАБЫТЫ БЫЛИ ИЗНАЧАЛЬНО, И ПОЛОСА ИЗ-ЗА ЭТОГО ДОХОДИЛА ДО СТА РАНЬШЕ
 * ЗАГРУЗКИ. Замерено на собранной игре: вход в водоём тянет 48.8 МБ, а
 * знаменатель показывал 38.0 — ровно на эти пять мегабайт меньше. Файлы
 * приезжают, но для счётчика их не существует: ни в числителе, ни в
 * знаменателе. Значит доля скачанного завышена, и «100 %» наступает, когда
 * ещё едет камыш.
 *
 * Грузит их nature/reeds.ts и nature/lilies.ts — не по нашей просьбе, а сами,
 * при сборке материалов берега.
 */
const ЗЕЛЕНЬ = [
  '/textures/reed_stalk_texture.jpg',
  '/textures/reed_leaf_texture.png',
  '/textures/reed_head_texture.jpg',
  '/textures/lily_pad_texture.jpg',
  '/textures/lily_petal.jpg',
];

/**
 * ⚠️ РЫБЫ В ЭТОМ СПИСКЕ БОЛЬШЕ НЕТ, И ЭТО НЕ ЗАБЫВЧИВОСТЬ. Её модели теперь
 * качаются ПОСЛЕ того, как игрок уже в мире (см. main.ts, запуск загрузки
 * рыбы по loader.готовность). Считать в знаменателе то, что начнёт грузиться
 * лишь после ухода загрузчика, значит обещать полосе конец, до которого она
 * не дойдёт никогда.
 */
/**
 * ⚠️ ВЫВЕЗЕН НАРУЖУ РАДИ СТЕНДА, И ЭТО ЕДИНСТВЕННАЯ ПРИЧИНА. Проверять строку
 * загрузки, качая ЧАСТЬ списка, нельзя: она показывает то, что ещё не
 * приехало, и при недокачанном хвосте никогда не опустеет — стенд объявил бы
 * поломкой правильное поведение. Ровно это и вышло при первой пробе.
 */
export const СПИСОК = [...СНАСТЬ, ...ЗЕМЛЯ, ...ЗЕЛЕНЬ];

/** Пути без «?v=2»: браузер сообщает о ресурсе именно так. */
const свои = new Set(СПИСОК.map((а) => а.split('?')[0] as string));

/** Известный размер файла: из заголовка или из завершившейся загрузки. */
const размеры = new Map<string, number>();
/** Сколько байт этого файла уже приехало. */
const пришлоПоФайлу = new Map<string, number>();

/**
 * Кусок самой игры: `/assets/main-XXXX.js` и его соседи.
 *
 * ⚠️ ИМЕНИ МЫ НЕ ЗНАЕМ ЗАРАНЕЕ — В НЁМ ОТПЕЧАТОК СОДЕРЖИМОГО, и меняется он
 * с каждой сборкой. Поэтому узнаём по месту и расширению, а размер берём из
 * той же записи о загрузке, что и байты: он приходит вместе с ней.
 */
function движковый(путь: string): boolean {
  return путь.startsWith('/assets/') && путь.endsWith('.js');
}

function наш(путь: string): boolean {
  return свои.has(путь) || движковый(путь);
}

function путьРесурса(адрес: string): string | null {
  try {
    return new URL(адрес, location.href).pathname;
  } catch {
    return null;
  }
}

/**
 * Как назвать файл в строке.
 *
 * ⚠️ ИМЯ ФАЙЛА КАК ЕСТЬ, БЕЗ ПУТИ И БЕЗ ПРИДУМАННЫХ НАЗВАНИЙ. Была попытка
 * называть по-человечески — «снасть», «земля берега», — и она хуже сразу по
 * двум причинам. Во-первых, такие имена приходится держать в согласии с тем,
 * что лежит в public, а расходятся они молча. Во-вторых, строка эта — журнал
 * работы, и её ценность в том, что по ней видно ИМЕННО ТОТ файл, на котором
 * дело встало: с ним можно пойти в панель разработчика, в журнал сервера,
 * в письмо о поломке. «Снасть» туда не отнесёшь.
 */
function назвать(путь: string): string {
  return путь.split('/').pop() ?? путь;
}

/*
 * ── Строка «что грузится» ─────────────────────────────────────────────────
 *
 * ⚠️ ЧЕРЕЗ НЕЁ ИДУТ ВСЕ ФАЙЛЫ ПОДРЯД, А НЕ ТОЛЬКО ИЗ СПИСКА. Список наверху
 * нужен для ЧИСЛА — по нему считается доля скачанного, и лишнее имя в нём
 * раздуло бы знаменатель. Строке же считать нечего: её дело показать работу,
 * и показывать она обязана всё, что и правда едет по сети, — куски сборки,
 * модели, карты, звук, что угодно. Иначе выходит, что игра тянет файл, а на
 * экране написано другое.
 *
 * ⚠️ НЕ ЧАЩЕ ЧЕМ РАЗ В ПОЛСЕКУНДЫ. Заплата на XHR шлёт события десятками в
 * секунду; без придержки имена мелькали бы так, что прочесть нельзя ни одного.
 *
 * ⚠️ И СТРОКА САМА ГАСНЕТ В ТИШИНЕ. Скачивание кончилось, а загрузчик ещё
 * стоит — строятся чанки, собираются шейдеры. Оставь мы последнее имя на
 * экране, человек читал бы это как «всё ещё качается»; ровно так и вышло на
 * первой пробе, где на семидесяти пяти процентах висело «краска снасти».
 */
const ШАГ_СТРОКИ_МС = 480;
const ТИШИНА_МС = 2000;
let сдвинутоВ = 0;
let гасилка = 0;

/**
 * Едет ли сейчас сам движок.
 *
 * ⚠️ ПОКА ОН ЕДЕТ, СТРОКА ГОВОРИТ ТОЛЬКО О НЁМ. Модульный ввоз молчит до
 * самого конца — ни байта, ни события, — зато ответы на HEAD-запросы о
 * размерах приходят за пару секунд. Без этого запрета выходило так: строка
 * успевала показать первый попавшийся файл и застывала на нём на все сорок
 * пять секунд, пока ехали семь мегабайт движка.
 */
let движокВПути = false;

export function движокПошёл(): void {
  движокВПути = true;
  /*
   * ⚠️ ИМЯ БЕРЁМ ТО, ЧТО ВВОЗИМ. Собранные куски зовутся с отпечатком
   * («babylon-zzWtZGaU.js»), и заранее их имён не знает никто.
   */
  loader.файл('main.js', 0);
}

export function движокПриехал(): void {
  движокВПути = false;
}

/** Показать имя файла в строке. Зовётся на КАЖДЫЙ ресурс, не только из списка. */
function показатьФайл(путь: string, размер: number): void {
  if (движокВПути) return;
  const сейчас = performance.now();
  if (сейчас - сдвинутоВ < ШАГ_СТРОКИ_МС) return;
  сдвинутоВ = сейчас;
  loader.файл(назвать(путь), размер);
  if (гасилка !== 0) clearTimeout(гасилка);
  гасилка = window.setTimeout(() => {
    гасилка = 0;
    loader.файл('', 0);
  }, ТИШИНА_МС);
}

/** Показать накопленное. Итог может быть ещё неизвестен — это не беда. */
function показать(): void {
  let пришло = 0;
  for (const б of пришлоПоФайлу.values()) пришло += б;
  let всего = 0;
  for (const р of размеры.values()) всего += р;

  /*
   * ⚠️ ПОЛОСКА ДВИГАЕТСЯ ТЕМИ ЖЕ БАЙТАМИ, ЧТО И СТРОКА ПОД НЕЙ, И БЕЗ ЭТОГО
   * ОНА ПРОСТО СТОИТ. Этап «разматываю катушку» отмечался ровно дважды: пять
   * процентов при начале и сто при конце. А между ними — вся тяжёлая
   * загрузка: игрок видел «2 %» и рядом «24 МБ из 49.5», то есть полоска
   * спорила с собственной подписью, а потом прыгала на треть разом.
   *
   * ⚠️ ИТОГ РАСТЁТ ПО ХОДУ ДЕЛА, ПОЭТОМУ ДОЛЯ МОЖЕТ ПЯТИТЬСЯ. Размеры кусков
   * игры узнаются лишь когда те докачаются, и знаменатель прибавляется
   * скачком. Полоска пятиться не должна ни при каких обстоятельствах —
   * loader.шаг помнит наибольшее и назад не идёт.
   */
  /*
   * ⚠️ ПОЛА БОЛЬШЕ НЕТ. Стояло `Math.max(0.05, …)` — и вместе с полом 0.5 из
   * boot.ts это давало полосе нижнюю границу, ниже которой она не опускалась,
   * а значит и не двигалась, пока настоящие байты её не перебьют. Тишину
   * между событиями закрывает теперь ползок показа (ui/loader.ts), и подпирать
   * долю выдуманными числами больше не нужно.
   */
  if (всего > 0) {
    loader.шаг('движок', Math.min(1, пришло / всего));
  }
}

/**
 * Отметить, сколько байт файла уже приехало.
 *
 * ⚠️ БЕРЁМ НАИБОЛЬШЕЕ, А НЕ ПРИБАВЛЯЕМ. Об одном и том же файле сообщают
 * двое: заплата на XHR — по ходу дела, наблюдатель — в конце. Складывай мы
 * их, и каждый файл посчитался бы дважды.
 */
function учесть(путь: string, байт: number): void {
  if (!(байт > 0)) return;
  const было = пришлоПоФайлу.get(путь) ?? 0;
  if (байт <= было) return;
  пришлоПоФайлу.set(путь, байт);
  показать();
}

/** Сколько байт этого ресурса реально приехало. */
function весЗаписи(з: PerformanceResourceTiming): number {
  // ⚠️ ТРИ ПОЛЯ, И БЕРЁМ НАИБОЛЬШЕЕ. transferSize равен нулю у взятого из
  // кеша, encodedBodySize — у ответов без нужных заголовков. Ноль вместо
  // честного размера означал бы, что счётчик стоит на месте при живой
  // загрузке; это хуже, чем небольшая неточность.
  return Math.max(з.transferSize || 0, з.encodedBodySize || 0, з.decodedBodySize || 0);
}

/** Размер файла по заголовку. Не ответил — ноль, и это не беда. */
async function размер(адрес: string): Promise<number> {
  try {
    const ответ = await fetch(адрес, { method: 'HEAD' });
    if (!ответ.ok) return 0;
    return Number(ответ.headers.get('content-length') ?? 0);
  } catch {
    return 0;
  }
}

let ужеЗавели = false;
let вернутьOpen: (() => void) | null = null;
let вернутьSend: (() => void) | null = null;

/**
 * Завести счётчик. Зовётся из boot.ts ДО ввоза движка.
 *
 * ⚠️ ЧЕМ РАНЬШЕ, ТЕМ ЛУЧШЕ, И ЭТО ВЕСЬ СМЫСЛ. Отсюда и наблюдатель, и
 * заплата на XHR, и опрос размеров успевают встать на место прежде, чем
 * пойдёт первый тяжёлый файл.
 */
export function завестиСчётчикЗагрузки(): void {
  if (ужеЗавели) return;
  ужеЗавели = true;

  /*
   * ⚠️ СНАЧАЛА ПОДПИСКА, ПОТОМ ОПРОС РАЗМЕРОВ. Наоборот было бы дырой: пока
   * идут HEAD-запросы, часть файлов успевает приехать, и их байты не попали
   * бы в счёт — полоса до конца не дошла бы никогда.
   *
   * ⚠️ buffered: true ДОБИРАЕТ УЖЕ СЛУЧИВШЕЕСЯ — то, что успело загрузиться
   * до этой строки.
   */
  /*
   * ⚠️ ОТСЕКАЕМ ВСЁ, ЧТО ПРИЕХАЛО ДО ЭТОГО МИГА, И БЕЗ ЭТОГО СОБРАННАЯ ИГРА
   * ПРЫГАЕТ НА 45 % В ПЕРВОЕ ЖЕ МГНОВЕНИЕ.
   *
   * `движковый()` считает своим любой `/assets/*.js`, а к моменту нажатия «На
   * рыбалку» такие уже скачаны — вход и журнал базы, вместе около 600 КБ. С
   * `buffered: true` наблюдатель честно отдаёт их повтором, и оба попадают
   * разом и в числитель, и в знаменатель: пришло 600 КБ из 600 КБ, то есть
   * доля движка единица — весь этап целиком, до первого байта локации. Ответы
   * на HEAD-запросы приходят позже и знаменатель поправляют, но доля назад не
   * ходит, и полоса остаётся завышенной до самых чанков.
   *
   * В деве этого не видно вовсе: там модули идут из `/src/`, под `движковый`
   * не подходят, и баг живёт ровно в той сборке, которую видит игрок.
   */
  const началось = performance.now();

  try {
    const наблюдатель = new PerformanceObserver((записи) => {
      for (const з of записи.getEntries() as PerformanceResourceTiming[]) {
        const путь = путьРесурса(з.name);
        if (путь === null) continue;
        if (з.startTime < началось) continue;
        const вес = весЗаписи(з);
        /*
         * ⚠️ СТРОКЕ ОТДАЁМ ВСЁ, СЧЁТУ — ТОЛЬКО СВОЁ. Доля скачанного считается
         * по заранее известному списку, и чужой файл в знаменателе сдвинул бы
         * её. А строка обязана называть то, что и правда едет, — иначе игра
         * тянет одно, а на экране написано другое.
         */
        показатьФайл(путь, вес);
        if (!наш(путь)) continue;
        // У куска игры размер узнаётся только здесь — своего HEAD у него нет.
        if (движковый(путь) && вес > 0) размеры.set(путь, вес);
        учесть(путь, вес);
      }
    });
    наблюдатель.observe({ type: 'resource', buffered: true });
    // Считать вечно незачем: как игра поднялась, счётчик больше не виден.
    window.setTimeout(() => закончить(наблюдатель), 180000);
  } catch {
    // Нет PerformanceObserver — останутся байты от заплаты на XHR.
  }

  подсмотретьXHR();
  подсмотретьКартинки();

  // ⚠️ РАЗМЕРЫ СПРАШИВАЕМ ПОЗЖЕ — см. спроситьРазмеры ниже.
}

/**
 * Узнать вес будущих файлов мира.
 *
 * ⚠️ РАНЬШЕ ЭТОТ ЗАЛП УХОДИЛ ПРЯМО ПЕРЕД ВВОЗОМ ДВИЖКА, И ЭТО РОНЯЛО ИГРУ
 * НА iPhone. Двадцать два запроса разом, а следом семимегабайтный кусок —
 * и всё это в шесть соединений, больше браузер к одному узлу не открывает.
 * На Blink кусок просто ждал своей очереди, а WebKit ждать не стал и отдал
 * отказ: «Importing a module script failed». Разведчик того же файла с
 * пустой страницы ввозил его без единой заминки — потому что рядом не было
 * этих двадцати двух.
 *
 * ⚠️ ПО ЧЕТЫРЕ ЗА РАЗ, А НЕ ВСЕ СРАЗУ. Даже когда движок уже в руках, залп
 * в два десятка соединений отбирает полосу у того, ради чего он и затеян, —
 * у загрузки самих файлов мира.
 */
export async function спроситьРазмеры(): Promise<void> {
  const очередь = [...СПИСОК];
  const работник = async (): Promise<void> => {
    for (;;) {
      const адрес = очередь.shift();
      if (адрес === undefined) return;
      const п = путьРесурса(адрес);
      const р = await размер(адрес);
      if (п !== null && р > 0) размеры.set(п, р);
    }
  };
  await Promise.all([работник(), работник(), работник(), работник()]);
  let всего = 0;
  for (const р of размеры.values()) всего += р;
  лог(`загрузка водоёма: ${(всего / 1048576).toFixed(1)} МБ по ${размеры.size} файлам`);
  показать();
}

/**
 * Заплата на XMLHttpRequest: считать байты прямо в полёте.
 *
 * ⚠️ БЕЗ НЕЁ СЧЁТЧИК СТОИТ И ПРЫГАЕТ. Модели Babylon грузит именно XHR, а у
 * него есть progress с полем loaded — то самое «сколько уже приехало», ради
 * которого всё и затевалось. Наблюдатель за ресурсами такого не умеет: он
 * сообщает о файле, только когда тот докачан.
 *
 * ⚠️ ЧУЖОЙ ВЫЗОВ ПРОПУСКАЕМ КАК ЕСТЬ, ЧТО БЫ НИ СЛУЧИЛОСЬ. Через этот же
 * open идут все запросы игры; урони мы здесь ошибку — и не загрузится ничто.
 */
/*
 * ── Очередь загрузок: один файл за раз ───────────────────────────────────
 *
 * ⚠️ ЗАВЕДЕНА ПРОТИВ СЕТЕВОЙ ДАВКИ, И ЭТО ЗАМЕРЕННАЯ БЕДА, А НЕ
 * ПРЕДОСТОРОЖНОСТЬ. Браузер держит к одному узлу шесть соединений. Игра же
 * просит мир залпом: два десятка моделей и текстур разом, среди них файлы по
 * три-четыре мегабайта. На Blink это лишь медленно, а WebKit (весь iPhone,
 * включая тамошний Chrome) на переполненной очереди бросает запросы — и
 * загрузка встаёт без единой ошибки.
 *
 * ⚠️ ОЧЕРЕДЬ ЗДЕСЬ, А НЕ В ПОЛУТОРА ДЕСЯТКАХ МЕСТ ЗАГРУЗКИ. Модели идут
 * через XHR, текстуры — через картинку; правь мы каждое место отдельно, треть
 * из них забылась бы уже завтра. Сеть — общее горлышко, там и очередь.
 *
 * ⚠️ ЧУЖОЕ НЕ ЗАДЕРЖИВАЕМ. В очередь идут только файлы мира с нашего же
 * узла. Разговор с игровым сервером и опрос сокета обязаны идти немедленно:
 * задержи мы их за четырёхмегабайтной текстурой — игра потеряет связь.
 *
 * ⚠️ СЛОТ ОСВОБОЖДАЕТСЯ ПО СРОКУ, ЧТО БЫ НИ СЛУЧИЛОСЬ. Один зависший файл
 * иначе запер бы всю очередь навсегда, и это была бы поломка хуже исходной.
 */
const ОЧЕРЕДЬ_СРОК_МС = 20000;

const ждут: Array<() => void> = [];
let занято = false;

/**
 * Снять порядок «один файл за раз».
 *
 * ⚠️ ЗОВЁТСЯ, КОГДА ИГРА ОТКРЫЛАСЬ, И НЕ ПОЗЖЕ. Очередь бережёт слабый браузер
 * на загрузке, но в самой игре берег подгружается на ходу: держи мы его в
 * узкой очереди — мир строился бы по одному кусочку за круг до сервера.
 */
export function снятьОчередьЗагрузок(): void {
  ждут.splice(0).forEach((пора) => пора());
  занято = false;
  if (вернутьSend !== null) {
    вернутьSend();
    вернутьSend = null;
  }
}

/** Наш ли это файл мира: только свой узел и только знакомые папки. */
function файлМира(адрес: string): boolean {
  try {
    const у = new URL(адрес, window.location.href);
    if (у.origin !== window.location.origin) return false;
    return /\.(glb|gltf|jpg|jpeg|png|webp|ktx2?|bin)$/i.test(у.pathname);
  } catch {
    return false;
  }
}

function пустить(): void {
  if (занято) return;
  const следующий = ждут.shift();
  if (следующий === undefined) return;
  занято = true;
  следующий();
}

/** Дождаться своей очереди. Возвращает «отпустить». */
async function вОчередь(имя: string): Promise<() => void> {
  await new Promise<void>((пора) => {
    ждут.push(пора);
    пустить();
  });
  loader.файл(имя, размеры.get(имя) ?? 0);
  let отпущено = false;
  const сторож = window.setTimeout(() => отпустить(), ОЧЕРЕДЬ_СРОК_МС);
  function отпустить(): void {
    if (отпущено) return;
    отпущено = true;
    clearTimeout(сторож);
    занято = false;
    пустить();
  }
  return отпустить;
}

/**
 * Картинки тоже идут очередью.
 *
 * ⚠️ БЕЗ ЭТОГО ОЧЕРЕДЬ ПОЛОВИНЧАТА: модели через XHR она задержит, а текстуры
 * — самые тяжёлые файлы игры — полетят мимо неё все разом, потому что их
 * грузит не XHR, а обычная картинка.
 */
function подсмотретьКартинки(): void {
  const свойство = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
  if (свойство?.set === undefined) return;
  const былSet = свойство.set;
  Object.defineProperty(HTMLImageElement.prototype, 'src', {
    ...свойство,
    set(this: HTMLImageElement, адрес: string) {
      if (typeof адрес !== "string" || !файлМира(адрес)) {
        былSet.call(this, адрес);
        return;
      }
      const путь = путьРесурса(адрес);
      void вОчередь(путь === null ? адрес : назвать(путь)).then((отпустить) => {
        this.addEventListener('load', () => отпустить(), { once: true });
        this.addEventListener('error', () => отпустить(), { once: true });
        былSet.call(this, адрес);
      });
    },
  });
}

function подсмотретьXHR(): void {
  const былOpen = XMLHttpRequest.prototype.open;
  вернутьOpen = () => {
    XMLHttpRequest.prototype.open = былOpen;
  };
  XMLHttpRequest.prototype.open = function (
    this: XMLHttpRequest,
    метод: string,
    адрес: string | URL,
    ...остальное: unknown[]
  ): void {
    // Адрес нужен `send`, а туда его не передают: помечаем сам запрос.
    (this as XMLHttpRequest & { __ifАдрес?: string }).__ifАдрес = String(адрес);
    try {
      const путь = путьРесурса(String(адрес));
      if (путь !== null && наш(путь)) {
        this.addEventListener('progress', (e: ProgressEvent) => {
          учесть(путь, e.loaded);
        });
      }
    } catch {
      // Не разобрали адрес — просто не считаем этот запрос.
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    (былOpen as unknown as (...а: unknown[]) => void).call(this, метод, адрес, ...остальное);
  } as typeof XMLHttpRequest.prototype.open;

  /*
   * ⚠️ ЗАДЕРЖИВАЕМ В `send`, А НЕ В `open`. Открытие ничего не шлёт и часто
   * идёт задолго до отправки; задержи мы его — сломался бы порядок настройки
   * запроса (заголовки, тип ответа), который ставят между open и send.
   */
  const былSend = XMLHttpRequest.prototype.send;
  вернутьSend = () => {
    XMLHttpRequest.prototype.send = былSend;
  };
  XMLHttpRequest.prototype.send = function (
    this: XMLHttpRequest,
    тело?: Document | XMLHttpRequestBodyInit | null,
  ): void {
    const адрес = (this as XMLHttpRequest & { __ifАдрес?: string }).__ifАдрес ?? "";
    if (!файлМира(адрес)) {
      былSend.call(this, тело ?? null);
      return;
    }
    const путь = путьРесурса(адрес);
    void вОчередь(путь === null ? адрес : назвать(путь)).then((отпустить) => {
      this.addEventListener('loadend', () => отпустить(), { once: true });
      былSend.call(this, тело ?? null);
    });
  } as typeof XMLHttpRequest.prototype.send;
}

function закончить(н: PerformanceObserver): void {
  try {
    н.disconnect();
  } catch {
    // Уже отключён — не беда.
  }
  if (вернутьOpen !== null) {
    вернутьOpen();
    вернутьOpen = null;
  }
  /*
   * ⚠️ ОЧЕРЕДЬ СНИМАЕТСЯ ВМЕСТЕ СО СЧЁТЧИКОМ, И ЭТО ВАЖНО. Пока игрок на
   * загрузке, порядок «один файл за раз» бережёт слабый браузер; но в самой
   * игре чанки берега подгружаются на ходу, и держать их в узкой очереди
   * значило бы рисовать мир по одному кусочку за круг до сервера.
   */
  if (вернутьSend !== null) {
    вернутьSend();
    вернутьSend = null;
  }
  ждут.length = 0;
  занято = false;
}
